import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import Service from "../../../../services/workbooks";
import Modal from "../../../../constants/Modal";

type Props = {
  workbook_id: number
  t: any
  onRefresh: () => void; // Funkcja do odświeżania
};

type State = {
  date: Date | null;
  showModal: boolean;
  loading: boolean;
};

class PostTraining extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      date: new Date(),
      showModal: false,
      loading: false
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDateChange(date: Date | null) {
    this.setState({ date: date });
  }

  handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { date } = this.state;
    const { workbook_id, onRefresh } = this.props;

    if (!date) {
      console.log("Wybierz datę treningu.");
      return;
    }

    this.setState({ loading: true }); // start spinnera

    try {
      await Service.postNewTraining(workbook_id, date);
      localStorage.setItem("expandedItemIndex", "0");
      if (onRefresh) onRefresh();
      this.setState({ showModal: false });
    } catch (error) {
      console.error("Błąd podczas dodawania treningu:", error);
    } finally {
      this.setState({ loading: false }); // stop spinnera
    }
  };

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }))
  };

  render() {
    const { t } = this.props;
    const { date, showModal, loading } = this.state;

    return (
      <div style={{ margin: '1em 0 1em 0' }}>

        <button onClick={this.toggleModal}>{t("workbooks.add_new_training_day")}</button>

        <Modal show={showModal} onClose={this.toggleModal} title={t("workbooks.select_training_date")}>
          <form onSubmit={this.handleSubmit}>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <DatePicker
                selected={this.state.date}
                onChange={this.handleDateChange}
                dateFormat="yyyy-MM-dd"
              />
            </div>

            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <span className="loader" />
              </div>
            ) : (
              <button type="submit" className="field">
                {t("buttons.add")}
              </button>
            )}
          </form>
        </Modal>

      </div>
    );
  }
}

export default withTranslation("global")(PostTraining)
